import { AppRoutes } from './routes/AppRoutes';

function AppStreamingAdmin() {
  return (
    <>
      <AppRoutes></AppRoutes>
    </>
  );
}

export default AppStreamingAdmin;
